import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { getMKeyCookie } from 'utils/cookies';

function Button({
  href,
  handleRoute,
  onClick,
  children,
  value,
  ...otherProps
}) {
  if (href) {
    // On the mobile app, we don't actually want some of the links to have SPA navigation (react-router),
    // so here we are rendering a traditional a tag if this is from the mobile app.
    // The mobile app requires full page loads when linking to the Tournament play page or the Game play page,
    // because the app has hooks that run special code on those two pages.
    const isMobile = getMKeyCookie();
    const LinkComponent = isMobile ? 'a' : Link;
    const linkParams = { [isMobile ? 'href' : 'to']: href };

    return (
      <LinkComponent
        {...linkParams}
        onClick={handleRoute}
        className="btn btn-primary"
        {...otherProps}
      >
        {value}
        {children}
      </LinkComponent>
    );
  }

  return (
    <button onClick={handleRoute} className="btn btn-primary" {...otherProps}>
      {value}
      {children}
    </button>
  );
}

Button.propTypes = {
  handleRoute: PropTypes.func,
  href: PropTypes.string,
  onClick: PropTypes.func,
  value: PropTypes.string,
  children: PropTypes.any
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/Button/index.js